import React, {Component, useEffect} from "react";
import {connect, useDispatch, useSelector} from "react-redux";
import {AppState} from "../RootReducer";
import {KycStatus, Settings, UserInfo} from "../http/protocol";
import MetamapComponent from "../ui/MetamapComponent";
import "./styles/ProfileMatiComponent.scss";
import {t} from "../i18n";
import {fetchUserInfo, setMetamapStatus as setMetamapStatus} from "../user/UserActions";
import {fetchSettings} from "../settings/SettingsActions";
import {Dispatch} from "redux";
import {getContainer} from "../ioc/IOCSetup";
import {UserService} from "../user/UserService";
import {usePrevious} from "../user/ui/utils";

interface State {
    clicked: boolean;
}


type AllProps = PropsFromState & PropsFromDispatch;

export class ProfileMetamapComponent extends Component<AllProps, State> {
    private userService: UserService | undefined = undefined;
    constructor(props: AllProps) {
        super(props);


        let user = this.props.user;
        if(user&& user.kycStatus) {
            this.props.setMetamapStatus(user.kycStatus);
        }

        this.state = {
            clicked: false,
        }

        // window.addEventListener("message", this.listener);
    }

    componentDidMount(): void {
        if(this.props.settings == undefined) {
            this.props.fetchSettings();
        }

        if(this.props.fetchUserInfo) {
            this.props.fetchUserInfo();
        }

        this.userService = getContainer().getUserService();
    }

    componentDidUpdate(prevProps: AllProps): void {
        if(this.props.user !== prevProps.user) {
            let user = this.props.user;
            if(user && user.kycStatus && user.kycStatus != KycStatus.NOT_STARTED) {
                this.props.setMetamapStatus(user.kycStatus);
            }
        }
    }

    handleClick = () => {
        this.setState({clicked: !this.state.clicked})
    }

    metamapExited = () => {
        this.setState({clicked: false})
    }


    renderKycStatus() {
        if(this.props.user) {
            //console.log("mati User KYC Status: ", this.props.metamapStatus)
            switch (this.props.metamapStatus) {
                case KycStatus.NOT_STARTED:
                    return <NotStarted handleClick={this.handleClick} />
                case KycStatus.PENDING:
                case KycStatus.REVIEW_NEEDED:
                    return <Pending  />
                case KycStatus.REJECTED:
                    return <Rejected />
                case KycStatus.VERIFIED:
                    return <Verified />
                default:
                    return <NotStarted handleClick={this.handleClick} />
            }
        } else {
            return <NotStarted handleClick={this.handleClick} />
        }
    }

    render(){

        return (
            <React.Fragment>
                {
                    this.renderKycStatus()
                }
                <MetamapComponent clicked={this.state.clicked} exited={this.metamapExited} />
            </React.Fragment>
        )
    }
}

interface PropsFromState {
    settings?: Settings;
    user? : UserInfo;
    metamapStatus: KycStatus;
}

interface PropsFromDispatch {
    fetchSettings: typeof fetchSettings;
    fetchUserInfo: typeof  fetchUserInfo;
    setMetamapStatus: (status: KycStatus) => void;
}

const mapStateToProps = ({settings, user} : AppState) => {
    return {
        settings: settings.settings,
        user : user.user && user.user,
        metamapStatus: user.metamapStatus
    }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        fetchSettings: () => dispatch(fetchSettings() as any),
        fetchUserInfo : () => dispatch(fetchUserInfo() as any),
        setMetamapStatus : (status: KycStatus)=>dispatch(setMetamapStatus(status) as any)
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProfileMetamapComponent);



const NotStarted = (props: {handleClick: () => void}) => {
    return (
        <div className={"buttonWrap"}>
            <a  href={"#"} className="btn btn-cta full-width" onClick={props.handleClick}  >{t("metamap.button")}</a>
        </div>
    )
}

const Pending = () => {
    const dispatch = useDispatch();
    const kycStatus = useSelector((app : AppState) => app.user.user?.kycStatus);
    const prevKycStatus = usePrevious(kycStatus);
    useEffect(() => {
        const intervalId = setInterval(() => {
            dispatch(fetchUserInfo() as any);
        }, 10000)

        return () => { 
            clearInterval(intervalId)
        }
    }, []);

    useEffect(()=> {
        if(kycStatus && kycStatus != prevKycStatus && kycStatus != KycStatus.NOT_STARTED) {
            dispatch(setMetamapStatus(kycStatus));
        }
    },[kycStatus, prevKycStatus])

    return (
        <React.Fragment>
            <div className={"profile-metamap-container"}>
                <div className={"infoField pending"}>
                    <div className={"spinner-border"}></div>
                    <span>{t("metamap.pending")}</span>
                </div>
                <span className={"helptext pending"}>{t("metamap.pendingHelpText")}</span>
            </div>
        </React.Fragment>
    )
}

const Verified = (props: any) => {
    return (
        <React.Fragment>
            <div className={"profile-metamap-container"}>
                <div className={"infoField verified"}>
                    <div className={"icon"}>
                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="img" viewBox="0 0 512 512">
                            <path fill="currentColor" d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"/>
                        </svg>
                    </div>
                    <span>{t("metamap.verified")}</span>
                </div>
            </div>
        </React.Fragment>
    )
}

const Rejected = () => {
    return (
        <React.Fragment>
            <div className={"profile-metamap-container"}>
                <div className={"infoField rejected"}>
                    <div className={"iconRejected"}>
                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="img" viewBox="0 0 512 512">
                            <path fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm101.8-262.2L295.6 256l62.2 62.2c4.7 4.7 4.7 12.3 0 17l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L256 295.6l-62.2 62.2c-4.7 4.7-12.3 4.7-17 0l-22.6-22.6c-4.7-4.7-4.7-12.3 0-17l62.2-62.2-62.2-62.2c-4.7-4.7-4.7-12.3 0-17l22.6-22.6c4.7-4.7 12.3-4.7 17 0l62.2 62.2 62.2-62.2c4.7-4.7 12.3-4.7 17 0l22.6 22.6c4.7 4.7 4.7 12.3 0 17z"/>
                        </svg>
                    </div>
                    <span>{t("metamap.rejected")}</span>
                </div>
                <span className={"helptext rejected"}>{t("metamap.rejectedHelpText")}</span>
            </div>
        </React.Fragment>
    )
}